var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button--primary",class:_vm.classes},[_c('span',{staticClass:"button__icon"},[_vm._t("icon-left")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"button__icon"},[_vm._t("icon-right")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }